export default [
    'Medical',
    'Co-Working',
    'General Office',
    'Government',
];